import React from 'react';
import { Button, message, Popover, Typography, Grid ,Tooltip} from 'antd';
import { ShareAltOutlined, LinkOutlined, CheckOutlined, CopyOutlined } from '@ant-design/icons';

const { Text } = Typography;
const { useBreakpoint } = Grid;

const ShareButton = () => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;

  const handleShare = async () => {
    const url = window.location.href;
    const pageTitle = document.title;
    const shareText = `I found "${pageTitle}" interesting and thought you might like it too!`;

    const shareData = {
      title: pageTitle,
      text: shareText,
      url: url,
    };

    if (navigator.share) {
      try {
        await navigator.share(shareData);
        message.success({
          content: 'Shared successfully!',
          icon: <CheckOutlined />,
          duration: 2,
        });
      } catch (error) {
        if (error.name !== 'AbortError') {
          message.error('Sharing was cancelled or failed');
        }
      }
    } else {
      try {
        await navigator.clipboard.writeText(`${shareText}\n\n${url}`);
        message.success({
          content: (
            <>
              <Text strong>Copied to clipboard!</Text><br />
              <Text type="secondary">Page title and link are ready to share</Text>
            </>
          ),
          icon: <CheckOutlined />,
          duration: 2,
        });
      } catch (err) {
        message.error('Failed to copy to clipboard');
      }
    }
  };

  const shareContent = (
    <div style={{ padding: '10px', maxWidth: '250px' }}>
      <Text strong>Share this content</Text>
      <br />
      <Text type="secondary">Spread knowledge with your network</Text>
    </div>
  );

  // Mobile version - compact icon button
  if (isMobile) {
    return (
      <div style={{ display: 'flex', gap: '8px' }}>
        <Popover content={shareContent} trigger="click">
          <Button
            type="primary"
            shape="circle"
            icon={<ShareAltOutlined />}
            onClick={handleShare}
            style={{
              background: 'linear-gradient(135deg, #1890ff, #722ed1)',
              border: 'none',
            }}
            size="large"
          />
        </Popover>
        
        <Tooltip title="Copy link">
          <Button
            type="text"
            shape="circle"
            icon={<CopyOutlined />}
            onClick={async () => {
              try {
                await navigator.clipboard.writeText(window.location.href);
                message.success('Link copied!');
              } catch (err) {
                message.error('Failed to copy link');
              }
            }}
            style={{ color: '#1890ff' }}
            size="large"
          />
        </Tooltip>
      </div>
    );
  }

  // Desktop version - full button with text
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Popover content={shareContent} trigger="hover">
        <Button
          type="primary"
          shape="round"
          icon={<ShareAltOutlined />}
          onClick={handleShare}
          style={{
            background: 'linear-gradient(135deg, #1890ff, #722ed1)',
            border: 'none',
            fontWeight: '500',
          }}
          size="middle"
        >
          Share This Page
        </Button>
      </Popover>
      
      <Tooltip title="Copy link">
        <Button
          type="text"
          icon={<LinkOutlined />}
          onClick={async () => {
            const pageTitle = document.title;
            const shareText = `Check out "${pageTitle}" at:`;
            try {
              await navigator.clipboard.writeText(`${shareText}\n${window.location.href}`);
              message.success('Link copied with page title!');
            } catch (err) {
              message.error('Failed to copy link');
            }
          }}
          style={{ color: '#1890ff' }}
          size="middle"
        />
      </Tooltip>
    </div>
  );
};

export default ShareButton;